module.exports = __webpack_public_path__ + "static/media/consumergoods2.a3866830.jpeg";